import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';

import { BaseService } from 'app/_services/base.service';
import { SettingsService } from "app/_services/settings.service";
import { UserService } from 'app/_services/user.service';

@Injectable({ providedIn: 'root' })
export class NewFeatureService extends BaseService {
    private _domain: string = '/general/new-features';

    constructor(private userService: UserService, private config: SettingsService) {
        super();
    }

    public getShouldShowBanner(): Observable<any> {
        let userRole = this.userService.user().role;

        return this.config.executeGet({ url: `${this._domain}/should-show-banner/${userRole}` });
    }

    public getUpdatesList(index: number, quantity: number): Observable<any> {
        let userRole = this.userService.user().role;

        return this.config.executeGet({ url: `${this._domain}/roles/${userRole}/index/${index}/take/${quantity}` });
    }

    public setLastNewFeatureSeenDate(): Observable<any> {
        return this.config.executePatch({ url: `${this._domain}/set-last-seen` });
    }
}
